import api from 'api';
import CustomModal from 'components/Common/CustomModal';
import Brand from 'layouts/Brand';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { inputStyle } from 'views/Orders/CreateOrder';

const ResetPassword = ({ handleModal, user }) => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const resetPassword = () => {
        if (newPassword !== confirmPassword) {
            toast.error("New password and confirm password do not match");
            return;
        }
        setLoading(true);

        api('put', '/auth/ByAdminChangePassword', { oldPassword, newPassword, confirmPassword, userId: user?._id })
            .then((res) => {
                toast.success(res.message);
                handleModal();
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    };

    return (
        <CustomModal loading={loading} handleSave={resetPassword} heading='Reset Password' buttonName='Reset' handleModal={handleModal}>
            <label style={labelStyle} htmlFor="newPassword">New Password</label><br />
            <input onChange={(e) => setNewPassword(e.target.value)} name='newPassword' value={newPassword} placeholder='Enter new password' style={inputStyle} type="password" /><br />

            <label style={labelStyle} htmlFor="confirmPassword">Confirm Password</label><br />
            <input onChange={(e) => setConfirmPassword(e.target.value)} name='confirmPassword' value={confirmPassword} placeholder='Confirm new password' style={inputStyle} type="password" />
        </CustomModal>
    );
};

const labelStyle = {
    marginTop: '10px',
    fontWeight: 600,
    fontSize: '16px',
    fontFamily: "Outfit",
    color: '#1C1C1C'
};

export default ResetPassword;